import styles from './EstimateDisclaimer.module.css'

/**
 * The approved label and disclaimer for `male_navy_circumference_v1`
 * (D-014, D-015, ui-ux-spec.md content rules).
 *
 * The label text is fixed. It is exported as a constant rather than typed
 * inline at each call site so it cannot drift, and so a test can assert the
 * exact string.
 *
 * Version 1 must never present this as exact, and must never show a numerical
 * practical range (D-015).
 */
export const NAVY_ESTIMATE_LABEL = 'Navy circumference estimate for men'

export const NAVY_ESTIMATE_DISCLAIMER =
  'This is an estimate for tracking your own change over time. It is not an official military ' +
  'compliance result, a clinical assessment, or an exact body-fat measurement.'

export const DERIVED_MASS_DISCLAIMER =
  'Estimated fat and lean mass are derived from the estimated body-fat percentage and carry the ' +
  'same uncertainty.'

export function EstimateDisclaimer() {
  return <p class={styles.disclaimer}>{NAVY_ESTIMATE_DISCLAIMER}</p>
}

export function DerivedMassDisclaimer() {
  return <p class={styles.disclaimer}>{DERIVED_MASS_DISCLAIMER}</p>
}
